export const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
export const FE_APP_VERSION = process.env.REACT_APP_VERSION;
export const MAPBOX_API_KEY = process.env.REACT_APP_MAPBOX_KEY;
export const API_URL = process.env.REACT_APP_API_URL;
export const SIGNALR_BACKEND_URL = process.env.REACT_APP_SIGNALR_BACKEND_URL; // Mock backend
export const COGNITO_AUTHORITY = process.env.REACT_APP_COGNITO_AUTHORITY;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI;
export const COGNITO_LOGOUT_URI = process.env.REACT_APP_COGNITO_LOGOUT_URI;
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN
export const CALL_HANDLER = "contactcentre";
export const CONTROL_TOWER = "controltower";
export const PATROL = "roadside";

console.log('VERSION', FE_APP_VERSION);